import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { AxiosInstance, AxiosPromise } from 'axios';
import {
  LoadboardListRequest,
  LoadboardListResponse,
  LoadboardRequest,
  LoadboardResponse,
  LoadboardDuplicatesResponse,
  LoadboardDuplicatesQueryParams,
  UnsyncedPostsResponse,
  UnsyncedPostsQueryParams,
  MarkPostSyncedResponse,
  SyncAllResponse,
  SyncJobForwardResponse,
  SyncJobForwardParams,
} from './LoadboardService.types';
import { CredentialService } from './services/CredentialService';

export class LoadboardService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  credential: CredentialService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.credential = new CredentialService(instance);
  }

  // list instead of a search because it does not take any parameters
  list(_request: LoadboardListRequest) {
    return this.instance.get<LoadboardListResponse>('/loadboards');
  }

  search(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  create(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  getById(_request: LoadboardRequest) {
    return this.instance.get<LoadboardResponse>(`/loadboards/${_request.routeParams.id}`);
  }

  update(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  delete(_request: {}): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  // Admin methods

  /**
   * GET /loadboards/admin/unsynced
   * Get paginated list of unsynced loadboard posts
   */
  getUnsyncedPosts(params: UnsyncedPostsQueryParams = {}) {
    return this.instance.get<UnsyncedPostsResponse>('/loadboards/admin/unsynced', { params });
  }

  /**
   * PUT /loadboards/admin/unsynced/{postGuid}
   * Mark a loadboard post as synced
   */
  markPostAsSynced(postGuid: string) {
    return this.instance.put<MarkPostSyncedResponse>(`/loadboards/admin/unsynced/${postGuid}`);
  }

  /**
   * POST /loadboards/admin/sync
   * Sync all unsynced loadboard posts
   */
  syncAllPosts() {
    return this.instance.post<SyncAllResponse>('/loadboards/admin/sync');
  }

  /**
   * PUT /loadboards/admin/jobs/{jobGuid}/sync-forward/{externalGuid}
   * Sync a specific job forward with external loadboard order
   */
  syncJobForward(params: SyncJobForwardParams) {
    return this.instance.put<SyncJobForwardResponse>(
      `/loadboards/admin/jobs/${params.jobGuid}/sync-forward/${params.externalGuid}`,
    );
  }

  /**
   * GET /loadboards/admin/duplicates
   * Search for duplicate loadboard orders by job number or GUID
   */
  searchDuplicates(params: LoadboardDuplicatesQueryParams) {
    return this.instance.get<LoadboardDuplicatesResponse>('/loadboards/admin/duplicates', {
      params,
    });
  }
}
